// src/features/notification/notificationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  newOrdersCount: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNewOrdersCount: (state, action) => {
      state.newOrdersCount = action.payload;
    },
    incrementNewOrders: (state) => {
      state.newOrdersCount += 1;
    },
    clearNewOrders: (state) => {
      state.newOrdersCount = 0;
    },
  },
});

export const {
  setNewOrdersCount,
  incrementNewOrders,
  clearNewOrders,
} = notificationSlice.actions;

export default notificationSlice.reducer;
